import React from 'react';

const ActionSheet = () => {
  return <></>;
}

export const SheetManager = {
  show: () => null,
  hide: () => null,
  hideAll: () => null,
};

export default ActionSheet;
